<template lang="pug">
    el-dialog(:title="!ruleForm.id ? '新建俱乐部': '修改俱乐部'",width="95%",:visible.sync='visible' :append-to-body='true' :modal-append-to-body='false')
        el-form(:model="ruleForm", :inline="false" :rules="rules", ref="ruleForm", label-width="100px", @submit.native.prevent)
            el-card(shadow="never")
                el-form-item(label="俱乐部名:" prop="name")
                    el-input.width_ct(v-model="ruleForm.name"  placeholder="请填写俱乐部名称" type="text" )
                //- el-form-item(label="add加盟方:" prop="chairman" )
                //-       el-select(v-model="ruleForm.provinceCode" placeholder="请选择加盟方",@change="changeProvice")
                //-         el-option(v-for="(item,index) in proviceList",:key="index",:label="item.name",:value="item.proviceId")
                div(style="display: flex;")
                  el-form-item(label='地区:' prop="provinceCode")
                      el-select(v-model="ruleForm.provinceCode" placeholder="请选择省" @change="changeProvice")
                          el-option(v-for="(item, index) in proviceList" :key="index" :label="item.name" :value="item.proviceId")
                      font(style="margin: 0 12px;") 省
                  el-form-item(label-width="0" prop="cityCode")
                      el-select(v-model="ruleForm.cityCode" placeholder="请选择市" @change="selectCity")
                          el-option(v-for="(item, index) in cityList" :key="index" :label="item.cityname" :value="item.cityId")
                      font(style="margin: 0 12px;") 市
                el-form-item(label="会长:" prop="chairman" )
                    el-input.width_ct(v-model="ruleForm.chairman" placeholder="请填写会长名" @focus="checktable")
                el-form-item(label="会长账号:" prop="chairmanId" )
                    el-input.width_ct(v-model="ruleForm.chairmanId" placeholder="请填写会长账号" @focus="checktable")
                el-form-item(label="全员女子:" prop="allWomen")
                    el-radio(v-model="ruleForm.allWomen" :label='1') 是
                    el-radio(v-model="ruleForm.allWomen" :label='2') 否
                el-form-item(label="等级:" prop="level")
                    el-select.sel_width_ct(v-model='ruleForm.level' placeholder="请选择等级" clearable)
                            el-option(label="甲A" :value="1")
                            el-option(label="甲B" :value="2")
                            el-option(label="乙A" :value="3")
                            el-option(label="乙B" :value="4")
                            el-option(label="丙A" :value="5")
                            el-option(label="丙B" :value="6")
                            el-option(label="丁A" :value="7")
                            el-option(label="丁B" :value="8")
                            el-option(label="资格甲" :value="9")
                            el-option(label="资格乙" :value="10")
                            el-option(label="资格丙" :value="11")
                            el-option(label="资格丁" :value="12")
                el-form-item(label="队 标:" prop="imgList")
                    el-input(v-model="ruleForm.teamLogo" v-show="false")
                    el-upload(:http-request="uploadFileList",action="useless" :before-upload="beforeAvatarUpload" :show-file-list="false" class="avatar-uploader")
                        img(v-if="listImageUrl" :src="listImageUrl" class="avatar" )
                        i(v-else class="el-icon-plus avatar-uploader-icon")
                    el-alert(title="建议最小分辨率80×80,上传图片格式仅支持jpg,jpeg,png,大小不超过10M" effect='light' :closable="false" style="margin-top:10px")
                //- el-form-item(label="add俱乐部照片:" prop="imgList")
                //-     el-upload(:http-request="uploadFileList",action="useless" :before-upload="beforeAvatarUpload" :show-file-list="false" class="avatar-uploader")
                //-         img(v-if="listImageUrl" :src="listImageUrl" class="avatar" )
                //-         i(v-else class="el-icon-plus avatar-uploader-icon")
                //-     el-alert(title="建议最小分辨率80×80,上传图片格式仅支持jpg,jpeg,png,大小不超过10M" effect='light' :closable="false" style="margin-top:10px")
                el-form-item(label="俱乐部照片:" prop="cbClubPhotoList")
                    i( class="el-icon-plus avatar-uploader-icon" style="width:240px;height:174px;" @click="openImgdailog(3)")
                    div(class='imagemore')
                        div(class='imagelist')
                            div(class='infocont' v-model='ruleForm.cbClubPhotoList'  v-for="(item,index) in listImageUrlCert" @mouseenter="hoverover(item)" @mouseleave="hoverout(item)")
                                div(class='deletes' v-if='deletesId === item.imgUrl')
                                    div(class='Mask')
                                    div
                                    <i :class="activecolor===item.imgUrl?'el-icon-delete chosecolor':'el-icon-delete'" @mouseenter="hoverover1(item)" @mouseleave="hoverout2(item)" @click="deletecertImg(item,index)"></i>
                                div
                                img(v-if="listImageUrlCert" :src="item.url" class="avatar" style="width:240px;height:174px;" @click="openImgdailog(3)")
                            div
                        div
                    div
                    imguploadMD(v-if="openImg" ref="upimg3" :width="240" :height="174" @uploadSuccess='doneup_Cert')
                    el-alert(title="建议最小分辨率240×175,上传图片格式仅支持jpg,jpeg,png,大小不超过10M" effect='light' :closable="false" style="margin-top:10px")
                el-form-item(label="俱乐部简介:" prop="intro")
                    d2-quill(ref="d2-quill" v-model="ruleForm.intro" style="min-height: 200px;")
        el-dialog(title="选择会长"  :visible.sync="addVisible" width="50%" :append-to-body='true' :modal-append-to-body='false')
            el-card(shadow="never")
                div(slot="header")
                    el-input(v-model='memberName' clearable='', style='width:80%;' placeholder="请输入姓名/级别/手机号码")
                    el-button(@click="queryLeftData" style='float:right;' icon='el-icon-search') 查询
            div
                el-table(:data="leftData" border  @selection-change="checkAll" max-height="300")
                    el-table-column(type="selection" align='center')
                    el-table-column(prop="name" label="姓名" align='center')
                    el-table-column(prop="gender" label="性别" align='center'  )
                        template(slot-scope="scope")
                            font(v-if="scope.row.gender === 0") 男
                            font(v-if="scope.row.gender === 1") 女
                    el-table-column(prop="level" label="级别" align='center')
                    el-table-column(prop="mobile" label="手机号码" align='center' )
                el-pagination(@size-change='sizeChangeHandle_mb', @current-change='currentChangeHandle_mb', :current-page='pageIndex_mb', :page-sizes='[10, 20, 50, 100]', :page-size='pageSize_mb', :total='totalPage_mb', layout='total, sizes, prev, pager, next, jumper')
            span.dialog-footer(slot="footer")
                el-button(@click="checkMber" type="primary") 确 定
                el-button(@click="addVisible=false") 取 消
        span.dialog-footer(slot="footer")
            el-button(type="primary" @click="ruleFormSubmit()") 确 定
            el-button(@click="visible=false") 取 消
</template>
<script>
export default {
  data () {
    return {
      activecolor: -1,
      deletesId: -1,
      flagType: '',
      proviceList: [],
      cityList: [],
      ruleForm: {
        id: null,
        name: '',
        chairman: '',
        chairmanId: '',
        level: null,
        allWomen: 2,
        teamLogo: '',
        intro: '',
        byx1: '',
        status: '',
        provinceCode: '',
        provinceName: '',
        cityCode: '',
        cityName: '',
        cbClubPhotoList: []
      },
      rules: {
        name: [
          { required: true, message: '俱乐部名不能为空!', trigger: 'blur' },
          { min: 2, max: 10, message: '俱乐部名长度在2到10个字符!' }
        ],
        provinceCode: [
          { required: true, message: '省不能为空!', trigger: 'change' }
        ],
        cityCode: [
          { required: true, message: '市不能为空!', trigger: 'change' }
        ],
        chairman: [
          { required: true, message: '会长名不能为空!', trigger: 'change' },
          // { max: 10, message: '长度不能超过10个字符!' }
        ],
        chairmanId: [
          { required: true, message: '会长账号不能为空!', trigger: 'change' }
        ],
        cbClubPhotoList: [
          // { required: true, message: '俱乐部照片不能为空!', trigger: 'change' }
        ]
      },
      visible: false,
      listImageUrl: '',
      detailImageUrl: '',
      openImg: false,
      addVisible: false,
      leftData: [],
      memberName: '',
      pageIndex_mb: 1,
      pageSize_mb: 10,
      totalPage_mb: 0,
      checkedItem: [],
      listImageUrlCert: []
    }
  },
  mounted () {},
  methods: {
    // 删除电子证书
    deletecertImg (item, index) {
      this.listImageUrlCert.splice(index, 1)
    },
    // 鼠标移入
    hoverover (item) {
      this.deletesId = item.imgUrl
    },
    hoverover1 (item) {
      this.activecolor = item.imgUrl
      // this.$nextTick(() => {
      //   this.activecolor = item.id
      // })
      // this.$set(this.activecolor, item.id)
    },
    // 鼠标移出
    hoverout (item) {
      this.deletesId = -1
    },
    hoverout2 (item) {
      this.activecolor = -1
    },
    //打开图片剪裁框
    openImgdailog (type) {
      this.openImg = true
      this.$nextTick(() => {
        if (type === 1) {
          this.$refs.upimg.init('ctLevel') //传入图片类型参数
        }
        if (type === 2) {
          this.$refs.upimg2.init('ctLevel') //传入图片类型参数
        }
        if (type === 3) {
          this.$refs.upimg3.init('ctLevel') //传入图片类型参数
        }
      })
    },
    init (id) {
      this.proviceList = []
      this.cityList = []
      this.listImageUrl = ''
      this.ruleForm.id = id || null
      this.ruleForm.provinceCode = ''
      this.ruleForm.cityCode = ''
      this.ruleForm.cbClubPhotoList = []
      this.listImageUrlCert = []
      this.$nextTick(() => {
        this.visible = true
        if (this.$refs['ruleForm']) {
          this.$refs['ruleForm'].resetFields()
          this.$refs['d2-quill'].Quill.pasteHTML('')
        }
      })
      this.$http({
        url: this.$http.adornUrl('/dicProvince/list'),
        method: 'get',
        params: this.$http.adornParams()
      })
        .then((data) => {
          this.proviceList = data && data.code === 0 ? data.list : []
        })
        .then(() => {
          if (this.ruleForm.id) {
            this.$http({
              url: this.$http.adornUrl(`/cbClub/getId/${this.ruleForm.id}`),
              method: 'get',
              params: this.$http.adornParams()
            }).then((data) => {
              if (data && data.code === 0) {
                this.ruleForm.provinceCode = data.bean.provinceCode
                this.ruleForm.cityCode = data.bean.cityCode

                this.ruleForm.name = data.bean.name
                this.ruleForm.chairman = data.bean.chairman
                this.ruleForm.chairmanId = data.bean.chairmanId
                this.ruleForm.allWomen = data.bean.allWomen
                this.ruleForm.level = data.bean.level
                this.ruleForm.status = data.bean.status
                this.ruleForm.byx1 = data.bean.byx1
                this.$refs['d2-quill'].Quill.pasteHTML(data.bean.intro)
                this.listImageUrl = data.bean.logoImgUrl

                if (data.bean.cbClubPhotoList.length !== 0) {
                  data.bean.cbClubPhotoList.forEach(element => {
                    let come = {
                      url: '',
                      imgUrl: '',
                      cbId: '',
                      id: ''
                    }
                    come.url = element.imgUrl
                    come.imgUrl = element.imgUrl
                    come.cbId = element.cbId
                    come.id = element.id
                    this.listImageUrlCert.push(come)
                  })
                }
              }
              this.changeProvice(0)
            })
          }
        })
    },
    changeProvice (flag) {
      if (flag != 0) {
        this.cityList = []
        this.ruleForm.cityCode = ''
        this.ruleForm.cityName = ''
      }
      // alert(1)
      this.$http({
        url: this.$http.adornUrl('/dicProvinceCity/list'),
        method: 'get',
        params: this.$http.adornParams({
          proviceId: this.ruleForm.provinceCode
        })
      }).then((data) => {
        let obj = {}
        let val = this.ruleForm.provinceCode
        if (val) {
          // alert(val)
          obj = this.proviceList.find((item) => {
            return item.proviceId === val
          })
          if (obj) {
            // alert(obj.name)
            this.ruleForm.provinceName = obj.name
          }
        }
        this.cityList = data && data.code === 0 ? data.list : []
        // 数据回显时需要把市一起回显
        if (flag === 0) {
          this.selectCity(0)
        }
      })
    },
    selectCity (flag) {
      if (flag !== 0) {
        this.venueList = []
        this.ruleForm.venueId = ''
      }
      this.$http({
        url: this.$http.adornUrl('/pbPlaces/getPlaceById'),
        method: 'get',
        params: this.$http.adornParams({
          orgId: this.ruleForm.userGroupId,
          proviceId: this.ruleForm.provinceCode,
          cityId: this.ruleForm.cityCode
        })
      }).then((data) => {
        let obj = {}
        let val = this.ruleForm.cityCode
        if (val) {
          obj = this.cityList.find((item) => {
            return item.cityId === val
          })
          if (obj) {
            this.ruleForm.cityName = obj.cityname
          }
        }
        this.venueList = data && data.code === 0 ? data.list : []
      })
    },
    getLeftData () {
      this.$http({
        url: this.$http.adornUrl(`/mbMember/getMemberListNoCb`),
        method: 'post',
        data: {
          page: this.pageIndex_mb,
          limit: this.pageSize_mb,
          name: this.memberName,
          job: 1 //选择会长
        }
      }).then((data) => {
        if (data && data.code === 0) {
          this.leftData = data.page.records
          this.totalPage_mb = data.page.total
        } else {
          this.leftData = []
          this.totalPage_mb = 0
        }
      })
    },
    // 每页数
    sizeChangeHandle_mb (val) {
      this.pageSize_mb = val
      this.pageIndex_mb = 1
      this.getLeftData()
    },
    // 当前页
    currentChangeHandle_mb (val) {
      this.pageIndex_mb = val
      this.getLeftData()
    },
    checkMber () {
      if (this.checkedItem.length === 0) {
        return this.$message.error('未勾选会员！')
      }
      if (this.checkedItem.length > 1) {
        return this.$message.error('只能勾选一个会员！')
      }
      this.ruleForm.chairman = this.checkedItem[0].name
      this.ruleForm.chairmanId = this.checkedItem[0].mobile
      this.ruleForm.byx1 = this.checkedItem[0].id
      this.addVisible = false
    },
    checkAll (val) {
      this.checkedItem = val
    },
    openFullScreen () {
      this.loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    },

    checktable () {
      this.getLeftData()
      this.addVisible = true
    },
    //新增方法
    ruleFormSubmit () {
      // if (this.listImageUrlCert.length == 0) {
      //   this.$message.error('请上传俱乐部照片!')
      // }
      this.ruleForm.cbClubPhotoList = this.listImageUrlCert
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.openFullScreen()
          this.ruleForm.option = 1
          this.$http({
            url: this.$http.adornUrl(
              `/cbClub/${!this.ruleForm.id ? 'save' : 'update'}`
            ),
            method: 'post',
            data: this.ruleForm
          })
            .then((data) => {
              if (data && data.code === 0) {
                this.$message({
                  message: '操作成功',
                  type: 'success',
                  duration: 1500,
                  onClose: () => {
                    this.visible = false
                    this.$emit('refreshDataList')
                    this.loading.close()
                  }
                })
              } else {
                this.$message.error(data.msg)
              }
            })
            .catch(() => {
              this.loading.close()
            })
        }
      })
    },

    //文件上传前的验证
    beforeAvatarUpload (file) {
      const isJPG =
        file.type === 'image/jpg' ||
        file.type === 'image/png' ||
        file.type === 'image/jpeg'
      const isLt2M = file.size / 1024 / 1024 < 1

      if (!isJPG) {
        this.$message.error('上传图片只能是 jpg,jpeg,png 格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传图片大小不能超过 10MB!')
      }
      return isJPG && isLt2M
    },

    //自定义上传方法
    //没有用el-upload的action方法，如果使用要传递headers属性参数授权
    uploadFileList (param) {
      //列表页图
      this.uploadFile('1', param.file)
    },
    uploadFileDetail (param) {
      //列表页图
      this.uploadFile('2', param.file)
    },
    //电子整数 列表页
    doneup_Cert (val, url) {
      // this.ruleForm.cbClubPhotoList = val
      let come = {
        url: url,
        imgUrl: val,
        id: val
      }
      this.listImageUrlCert.push(come)

      this.openImg = false
      this.ruleForm.cbClubPhotoList = this.listImageUrlCert

      // this.$refs.ruleForm.validateField('cbClubPhotoList')
      // this.rules.cbClubPhotoList = [{ required: true, message: '俱乐部照片不能为空' }]
    },
    uploadFile (type, file) {
      let fd = new FormData()
      fd.append('type', 'cbClub')
      fd.append('file', file)

      this.$http({
        url: this.$http.adornUrl(`/upload/uploadFile`),
        method: 'post',
        data: fd
      }).then((data) => {
        if (data && data.code === 0) {
          //列表页图
          if (type === '1') {
            this.ruleForm.teamLogo = data.bean.id
            this.listImageUrl = URL.createObjectURL(file)
          }
          //详情页图
          if (type === '2') {
            this.ruleForm.imgDetailList = data.bean.id
            this.detailImageUrl = URL.createObjectURL(file)
          }
          this.$message.success('上传成功!')
        } else {
          this.$message.error('上传失败!')
        }
      })
    },
    // 会长弹出框查询
    queryLeftData () {
      this.pageIndex_mb = 1
      this.getLeftData()
    }
  }
}
</script>
<style>
.imagemore {
  /* display: inline-block; */
  margin-top: 20px;
}
.imagelist {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;

  align-items: center;
}
.infocont {
  display: inline-block;
  margin-right: 30px;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-radius: 5px;
  overflow: hidden;
}
.deletes .el-icon-delete {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 100;
  color: white;
  font-size: 20px;
}
.chosecolor {
  color: #02b90d !important;
}
.deletes {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
}
.deletes .Mask {
  width: 100%;
  height: 100%;
  background: black;
  opacity: 0.8;
  position: absolute;
  left: 0;
  top: 0;
}
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.width_ct {
  width: 50%;
}
.sel_width_ct,
.input_width_ct {
  width: 20% !important;
}
.font_later {
  padding-left: 20px;
  font-weight: bold;
  color: #909399;
}
.font_color {
  font-weight: bold;
  color: #909399;
}
.font_style {
  font-weight: bold;
  color: red;
}
.dialog-footer {
  padding-bottom: 150px;
}
</style>
